import { SIM_BUILDER_API_END_POINT } from "../../Config";
import { encryptData } from "../../utils/utils";

const FeedbackReportItem = (props) => {
  const isFreeText = props.track.type;
  const trackType = props.track.type;

  const getHeadingForTrackType = () => {
    if (trackType === "question") {
      return "Learning Objective";
    } else if (trackType === "freetext") {
      return "Considerations";
    } else {
      return "Considerations - (Recorded Response Track)";
    }
  };

  const getResponseHeading = () => {
    if (trackType === "question") {
      return "Your Choice(s):";
    } else if (trackType === "freetext") {
      return "Your Response:";
    } else {
      return "Response Link";
    }
  };

  const renderResponse = (value) => {
    if (trackType !== "recorded") return value;

    if (value.trim() === "" && trackType === "recorded") {
      return value;
    } else {
      const url = `${SIM_BUILDER_API_END_POINT}/simResult/getVideoUrl/${encryptData(
        props.resultId
      )}`;
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault();
            window.open(url, "_blank");
          }}
        >
          {url}
        </a>
      );
    }
  };

  return (
    <div className="report_item">
      <h2>{props.prompt}</h2>
      {props.promptDetails && <p>{props.promptDetails}</p>}
      <h3>{getHeadingForTrackType()}</h3>
      <p>{props.lesson}</p>
      <h3>{getResponseHeading()}</h3>
      <ul>
        {props?.responseList?.map((choice, index) => (
          <li key={index}>{renderResponse(choice)}</li>
        ))}
      </ul>
      {props?.allResp && isFreeText === "question" && (
        <>
          <h3>Other Choices</h3>
          <ul>
            {props?.allResp?.map((choice, index) => {
              if (!props.responseList.includes(choice.response)) {
                return <li key={index}>{choice.response}</li>;
              }
              return "";
            })}
          </ul>
        </>
      )}

      {props.timeForResponse && (
        <>
          <h3>Decision Time</h3>
          <ul>{props.timeForResponse}</ul>
        </>
      )}

      {props.feedbackList && (
        <>
          <h3>Feedback</h3>
          <ul>
            {props?.feedbackList?.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default FeedbackReportItem;
